export default __webpack_public_path__ + "static/media/img_donghai_2.1e9d4e5b.png";